import { Pipe, PipeTransform } from '@angular/core';

/**
 * Join elements in a array by the given separator
 */
@Pipe({
    name: 'join',
})
export class JoinPipe implements PipeTransform {
    transform(list: string[], separator: string = ','): string {
        if(!list) return "?";
        return list.join(separator) || "";
    }
}
